// Centralized configuration for the Admin Panel
export const config = {
    env: process.env.NODE_ENV || 'development',
    // En producción y desarrollo usamos rutas relativas para que el Proxy inverso maneje el ruteo.
    // El proxy de desarrollo de Parcel o Traefik redirigirá /api hacia el backend.
    host: process.env.API_HOST || '',
    appName: process.env.APP_NAME || 'QR Smart Panel',
    isDev: process.env.NODE_ENV !== 'production'
};

// Expose to window for debugging purposes
window.appConfig = config;
